import { render, staticRenderFns } from "./VerificationCodeComponent.vue?vue&type=template&id=704cf682"
import script from "./VerificationCodeComponent.vue?vue&type=script&lang=ts"
export * from "./VerificationCodeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports